/**
 * A patient's N° de sécurité sociale (NIR / `secu`) is a REAL number only when it is exactly
 * 15 digits AND not the all-zeros placeholder `'000000000000000'` (the sentinel stored when a
 * patient has no secu yet). Mirrors the backend src/shared/validators/is-valid-nir.validator.ts
 * so the patient-app complete-profile validator + readiness gate agree with the server.
 */
export const NIR_PLACEHOLDER = '000000000000000'

export function isValidNir(secu?: string | null): boolean {
  return typeof secu === 'string' && /^\d{15}$/.test(secu) && secu !== NIR_PLACEHOLDER
}
